import React, { useMemo, useState } from 'react'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Text } from '../../components/ui'
import type { MarketingRequest } from '../../types/marketingSolicitacao'
import { formatRequestSelectLabel } from './notasUi'
import SolicitacaoSelectModal from './SolicitacaoSelectModal'

type Props = {
  label: string
  requests: MarketingRequest[]
  value: string
  onChange: (requestId: string) => void
  disabled?: boolean
  labelClassName?: string
  emptyLabel?: string
}

const SolicitacaoPickerField: React.FC<Props> = ({
  label,
  requests,
  value,
  onChange,
  disabled = false,
  labelClassName = 'mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300',
  emptyLabel = 'Nenhuma solicitação selecionada',
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const selected = useMemo(
    () => requests.find((request) => request.id === value) || null,
    [requests, value]
  )

  return (
    <div>
      <label className={labelClassName}>{label}</label>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-stretch">
        <div className="flex min-h-[2.5rem] flex-1 items-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm dark:border-gray-600 dark:bg-gray-900">
          {selected ? (
            <div className="flex w-full items-start justify-between gap-2">
              <Text size="sm" className="text-gray-900 dark:text-white">
                {formatRequestSelectLabel(selected)}
              </Text>
              {!disabled && (
                <button
                  type="button"
                  onClick={() => onChange('')}
                  className="shrink-0 rounded p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-700"
                  title="Limpar solicitação"
                >
                  <XMarkIcon className="h-4 w-4" />
                </button>
              )}
            </div>
          ) : (
            <Text size="sm" color="muted">
              {emptyLabel}
            </Text>
          )}
        </div>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          onClick={() => setModalOpen(true)}
          className="inline-flex shrink-0 items-center gap-2"
        >
          <MagnifyingGlassIcon className="h-4 w-4" />
          {selected ? 'Trocar' : 'Buscar solicitação'}
        </Button>
      </div>

      <SolicitacaoSelectModal
        open={modalOpen}
        requests={requests}
        value={value}
        onClose={() => setModalOpen(false)}
        onSelect={onChange}
      />
    </div>
  )
}

export default SolicitacaoPickerField
